import type { PropsWithChildren } from 'react';

import { useSection } from 'src/hooks/useSection';

import { ApplicationDomain } from 'src/routes/types';

import { useAppSelector } from 'src/hooks';
import { isLoadingEs } from 'src/store/trading/apiKeys/selectors';
import { useListVaults } from '@skynet/data-dex-vaults';
import { BlankLoading } from './BlankLoading';
import { ES_BOOTSTRAP_SECTION } from 'src/store/trading/listen-sections';

export function RedirectDefaults({ children }: PropsWithChildren) {
  const { domain, section, isLoading: sectionLoading } = useSection();

  const { isLoading: dexLoading } = useListVaults(
    { projectId: 0, all: 1, mine: 0, limit: 1000, page: 0 },
    {
      skip: domain !== ApplicationDomain.DEX,
    },
  );

  const tradingLoading = useAppSelector(isLoadingEs);
  // Only Tasks waits on the ES bootstrap. Bots does read the bootstrap's
  // supported-exchange list to pick its default exchange, so its first load can
  // still show the page briefly before that redirect lands — but it renders its
  // own (empty) group selector meanwhile, which beats blanking the whole
  // section out on every switch into it (SKY-4581).
  const isLoadingTrading =
    domain === ApplicationDomain.Trading && section === ES_BOOTSTRAP_SECTION && tradingLoading;
  const isLoading = sectionLoading || dexLoading || isLoadingTrading;

  if (isLoading) {
    return <BlankLoading />;
  }
  return <>{children}</>;
}
